import * as React from "react";
import AuthContext from "./AuthContext";
var AuthContainer = function (_a) {
    var client = _a.client, children = _a.children;
    var _b = React.useState(client.GetStatus()), status = _b[0], setStatus = _b[1];
    React.useEffect(function () { return client.Status.subscribe(setStatus).unsubscribe; }, [client]);
    return React.createElement(AuthContext.Provider, { value: { client: client, status: status } }, children);
};
export default AuthContainer;
